// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Rf7V","log":"ModalInventoryLogs_log__2HM7J","date":"ModalInventoryLogs_date__2a9VX","userName":"ModalInventoryLogs_userName__3bIt6"};